import { parseURI } from '@cian/http-api/shared';
import { IApplicationState } from '../../types/redux';

export function getQueryString({ path }: IApplicationState) {
  if (!path) {
    return '';
  }

  const { query } = parseURI(`https://www.cian.ru/${path}`);

  if (!query) {
    return '';
  }

  return query.replace('/', '');
}
